import "./namespace.js";
import "#/shared/api/api-host-global.js";
import "#/legacy/namespaces.js";
import "#legacy/utilities/ordered_ajax.js";
import "#legacy/utilities/params.js";

const CHATTERBOX_ENDPOINT = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.autocompleteSuggestedFilter
  : window.SparkleConfig.routes.embed.autocompleteSuggestedFilter;

DoctorFinder.Helpers.AutocompleteChatterBoxFetcher = class AutocompleteChatterBoxFetcher {
  constructor(endpoint = CHATTERBOX_ENDPOINT) {
    this.fetchChatterBoxData = this.fetchChatterBoxData.bind(this);
    this.endpoint = endpoint;
  }

  fetchChatterBoxData(query) {
    return Sparkle.Utilities.OrderedAJAX.getJSON(
      "doctor-finder-autocomplete-chatterbox",
      this.endpoint,
      jQuery.param({ query }),
    );
  }
};
